module.exports = __webpack_public_path__ + "static/img/land31.aa329bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/land31.svg
// module id = lNPZ
// module chunks = 0